import script from "./ZoomableAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./ZoomableAvatar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__